import React from 'react'
import BSModal from 'react-bootstrap/Modal'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { closeModal as dispatchCloseModal } from './modalSlice'
import { Modal as ModalType } from './types'
import { RootState } from '../../store'
import colors from '../../constants/colors'
import StyledIcon from '../../components/Icon'

interface ModalProps extends ModalType {
    closeModal: (id: number) => void;
}

const S = {
    BSModal: styled(BSModal)<{$backgroundColor?: string}>`
        background-color: ${({ $backgroundColor }) => $backgroundColor};
    `,
    Header: styled(BSModal.Header)`
        padding: 16px;
    `,
    HeaderInner: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        & + button {
            margin-top: -6px!important;
            font-size: 37px;
            font-weight: 400;
            &:focus {
                outline: none;
            }
        }
    `,
    Title: styled(BSModal.Title)`
        margin-top: auto;
        margin-bottom: auto;
        font-size: 20px;
        line-height: unset;
        color: ${colors.gray6};
        font-weight: bold;
    `,
    CloseModalIcon: styled.div`
        position: absolute;
        z-index: 1;
        top: 32px;
        right: 32px;
        cursor: pointer;
    `
}

const renderHeaderComponent = (Component) => <Component />

const Modal = ({
    id,
    header,
    closeModal,
    Component,
    size = 'lg',
    callback = () => undefined,
    padding = 16,
    showCloseIcon,
    backdrop = true,
    backgroundColor = 'rgba(0, 0, 0, 0.1)',
}: ModalProps) => {
    const [show, setShow] = React.useState(true)
    const close = (withAnimation = true) => {
        setShow(false)
        setTimeout(() => {
            closeModal(id)
            callback()
        }, withAnimation ? 250 : 0)
    }
    return !Component ? null : (
        <>
            <S.BSModal
                show={show}
                onHide={close}
                centered
                size={size}
                backdrop={backdrop}
                $backgroundColor={backgroundColor}
            >
                {
                    header
                    && (
                        <S.Header closeButton>
                            <S.HeaderInner>
                                {
                                    typeof header === 'string'
                                        ? <S.Title>{header}</S.Title>
                                        : renderHeaderComponent(header)
                                }
                            </S.HeaderInner>
                        </S.Header>
                    )
                }
                {showCloseIcon && show
                && (
                    <S.CloseModalIcon>
                        <StyledIcon
                            icon="close"
                            size={32}
                            onClick={() => close(true)}
                        />
                    </S.CloseModalIcon>
                )}
                <BSModal.Body style={{ padding }}>
                    <Component close={close} />
                </BSModal.Body>
            </S.BSModal>
        </>
    )
}

const ModalContainer = () => {
    const modals = useSelector((state: RootState) => state.modals)
    const dispatch = useDispatch()
    const keys = Object.keys(modals)
    return keys.length === 0 ? null : (
        <div>
            { keys.map((modalId) => (
                <Modal
                    {...modals[modalId]}
                    closeModal={(id: number) => dispatch(dispatchCloseModal(id))}
                    key={modalId}
                />
            ))}
        </div>
    )
}

export { S }
export default ModalContainer
